import script from "./Translator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Translator.vue?vue&type=script&setup=true&lang=ts"

import "./Translator.vue?vue&type=style&index=0&id=0fdcc2b8&lang=scss"

const __exports__ = script;

export default __exports__